import { translate } from "app/filters/i18nFilter";
import {
    FALLBACK_CHIP_BRANDS,
    FALLBACK_CHIP_COMPANIES,
    FALLBACK_CHIP_LEADERS,
} from "app/pages/activation/components/SetupModal/CompetitorsStep/texts";

export const EMPTY_STATE_IMAGE_SRC = "/images/activation/competitors-empty-state.svg";
export const MIN_VIEWPORT_HEIGHT = 800;
export const LIST_PARAMS = {
    width: 656,
    rowHeight: 84,
    entityRowHeight: 52,
    heightEntity: 312,
    height: 328,
    bigListHeight: 420,
    smallListHeight: 225,
};

export const REGEXP_COMPETITORS_DOMAINS = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;

export const REGEXP_VALID_DOMAIN_REMOVED_PROTOCOLS =
    /^(?:https?:\/\/)?(?:www\.)?([0-9A-Za-z][0-9A-Za-z-]{0,62}(?:\.[0-9A-Za-z][0-9A-Za-z-]{0,62})+)(?:\/.*)?$/;

export const TRIM_QUOTES_REG_EX = /"/g;
export const TRIM_SUB_SITE_REG_EX = /\/.*/;

export const COMPETITORS_WRAPPER_ID = "competitorsWrapperId";
const CHIPS_COUNT = 3;

export const getFallbackChips = () => [
    translate(FALLBACK_CHIP_LEADERS),
    translate(FALLBACK_CHIP_BRANDS),
    translate(FALLBACK_CHIP_COMPANIES),
];
